/* global axios */
import ApiClient from '../ApiClient';

// Подключения LLM-провайдеров (Р9.2): несколько ключей на аккаунт.
class AssistantProviderCredentials extends ApiClient {
  constructor() {
    super('assistant/provider_credentials', { accountScoped: true });
  }

  create(data = {}) {
    return axios.post(this.url, { credential: data });
  }

  update(id, data = {}) {
    return axios.patch(`${this.url}/${id}`, { credential: data });
  }

  // Р10 п.1: обновить каталог моделей подключения по API провайдера.
  syncModels(id) {
    return axios.post(`${this.url}/${id}/sync_models`);
  }
}

export default new AssistantProviderCredentials();
